import { useNavigate, useParams } from "react-router-dom";
import { cn } from "@/lib/utils/cn";
import { FunnelPane } from "./FunnelPane";
import { ActivosPane } from "./ActivosPane";
import { ValidacionPane } from "./ValidacionPane";
import { TareasPane } from "./TareasPane";
import { SprintsPane } from "./SprintsPane";
import { AreasPane } from "./AreasPane";
import { MetricasPane } from "./MetricasPane";
import { Seguridad360Pane } from "./Seguridad360Pane";
import { InvitationsScreen } from "../onboarding-invitations/InvitationsScreen";

const TABS = [
  { value: "funnel", label: "Funnel" },
  { value: "invitations", label: "Invitaciones" },
  { value: "activos", label: "Activos" },
  { value: "validacion", label: "Validación" },
  { value: "tareas", label: "Tareas equipo" },
  { value: "sprints", label: "Sprints" },
  { value: "areas", label: "Áreas" },
  { value: "metricas", label: "Métricas" },
  { value: "seguridad360", label: "Seguridad 360" },
] as const;

export function SeguimientoScreen() {
  const { tab } = useParams<{ tab: string }>();
  const navigate = useNavigate();
  const active = TABS.some((t) => t.value === tab) ? (tab as string) : "funnel";

  return (
    <div className="flex flex-col gap-4 animate-fade-in">
      <header className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="nx-eyebrow mb-1">Seguimiento</p>
          <h1 className="nx-h1">Seguimiento del equipo</h1>
          <p className="text-sm text-fg-muted mt-1">
            CRM de prospectos, activos, validación de módulos y tareas — la verdad del
            avance del MVP, sin Excel.
          </p>
        </div>
        <div className="inline-flex flex-wrap bg-bg-subtle border border-border rounded-md p-0.5">
          {TABS.map((t) => (
            <button
              key={t.value}
              onClick={() => navigate(`/seguimiento/${t.value}`)}
              className={cn(
                "px-3 py-1.5 text-xs font-medium rounded-sm transition-colors",
                active === t.value
                  ? "bg-bg-card text-fg shadow-nx-sm"
                  : "text-fg-muted hover:text-fg",
              )}
            >
              {t.label}
            </button>
          ))}
        </div>
      </header>

      {active === "funnel" && <FunnelPane />}
      {active === "invitations" && <InvitationsScreen embedded />}
      {active === "activos" && <ActivosPane />}
      {active === "validacion" && <ValidacionPane />}
      {active === "tareas" && <TareasPane />}
      {active === "sprints" && <SprintsPane />}
      {active === "areas" && <AreasPane />}
      {active === "metricas" && <MetricasPane />}
      {active === "seguridad360" && <Seguridad360Pane />}
    </div>
  );
}
